import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Amplify } from "aws-amplify";
import App from "./App";
import "./index.css";

// Amplify configuration — supports both email/password AND social login
// (Google, Apple, Amazon) via Cognito Hosted UI + OAuth2 code grant.
Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId:       import.meta.env.VITE_COGNITO_USER_POOL_ID as string,
      userPoolClientId: import.meta.env.VITE_COGNITO_USER_POOL_CLIENT_ID as string,
      // OAuth config enables social login buttons in Amplify UI
      loginWith: {
        oauth: {
          domain:            import.meta.env.VITE_COGNITO_OAUTH_DOMAIN as string
                             || "alphayou-auth.auth.eu-west-2.amazoncognito.com",
          scopes:            ["openid", "email", "profile"],
          redirectSignIn:    [
            import.meta.env.VITE_REDIRECT_SIGN_IN as string
            || window.location.origin + "/app",
          ],
          redirectSignOut:   [
            import.meta.env.VITE_REDIRECT_SIGN_OUT as string
            || window.location.origin,
          ],
          responseType:      "code" as const,
          // Social providers — Amplify UI shows buttons for each one
          // that is configured in the Cognito User Pool.
          // These are enabled/disabled by the CDK auth stack context vars.
          providers: [
            { custom: "Google" },
            { custom: "SignInWithApple" },
            { custom: "LoginWithAmazon" },
          ],
        },
      },
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
